'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasGivenConsentToProcess = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _reselect = require('reselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGdpr = (0, _get2.default)('gdpr');

var getHasGivenConsentToProcess = exports.getHasGivenConsentToProcess = (0, _reselect.createSelector)([getGdpr], (0, _get2.default)('hasVisitorGivenConsentToProcess'));


//////////////////
// WEBPACK FOOTER
// ./js/gdpr/selectors/getHasGivenConsentToProcess.js
// module id = 209
// module chunks = 2 3